import { RpcClient } from '@goblinhunt/cosmes/client'
import { RPC_URL } from './Constants'
import { CosmosBankV1beta1QueryAllBalancesResponse, CosmosBankV1beta1QueryAllBalancesService, CosmosStakingV1beta1DelegationResponse, CosmosStakingV1beta1QueryDelegationResponse, CosmosStakingV1beta1QueryDelegationService, CosmosStakingV1beta1QueryValidatorRequest, CosmosStakingV1beta1QueryValidatorResponse, CosmosStakingV1beta1QueryValidatorService, CosmosStakingV1beta1Validator, CosmwasmWasmV1QuerySmartContractStateResponse, CosmwasmWasmV1QuerySmartContractStateService } from '@goblinhunt/cosmes/protobufs'

export async function querySmartContract(address: string, queryMsg: object) {
    const res = await new Promise<CosmwasmWasmV1QuerySmartContractStateResponse>(
        (resolve, rej) => RpcClient
            .newBatchQuery(RPC_URL)
            .add(
                CosmwasmWasmV1QuerySmartContractStateService,
                {
                    address,
                    queryData: new Uint8Array(Buffer.from(JSON.stringify(queryMsg)))
                },
                (err, res) => err ? rej(err) : resolve(res)
            )
            .send()
    )
    return JSON.parse(Buffer.from(res.data).toString())
}

export async function queryLuncBalance(address: string) {
    let nextKey: Uint8Array | undefined = undefined;
    while (true) {
        const res = await new Promise<CosmosBankV1beta1QueryAllBalancesResponse>(
            (resolve, rej) => RpcClient
                .newBatchQuery(RPC_URL)
                .add(
                    CosmosBankV1beta1QueryAllBalancesService,
                    {
                        address,
                        pagination: {
                            key: nextKey
                        }
                    },
                    (err, res) => err ? rej(err) : resolve(res)
                )
                .send()
        )
        nextKey = res.pagination?.nextKey;
        if (!res.pagination?.nextKey) throw { message: "Balance not found" }

        const luncBalance = res.balances.find(e => e.denom == "uluna");
        if (luncBalance) return luncBalance;
    }
}

export async function queryValidator(validatorAddr: string) {
    const res = await new Promise<CosmosStakingV1beta1QueryValidatorResponse>(
        (resolve, rej) => RpcClient
            .newBatchQuery(RPC_URL)
            .add(
                CosmosStakingV1beta1QueryValidatorService,
                {
                    validatorAddr
                },
                (err, res) => err ? rej(err) : resolve(res)
            )
            .send()
    )
    return res.validator
}

export async function queryDelegation(validatorAddr: string, delegator: string) {
    const res = await new Promise<CosmosStakingV1beta1QueryDelegationResponse>(
        (resolve, rej) => RpcClient
            .newBatchQuery(RPC_URL)
            .add(
                CosmosStakingV1beta1QueryDelegationService,
                {
                    validatorAddr,
                    delegatorAddr: delegator
                },
                (err, res) => err ? rej(err) : resolve(res)
            )
            .send()
    )
    return res.delegationResponse
}